import { Route, Routes, Navigate } from 'react-router';
import { HomePage } from './pages/HomePage/HomePage';
import { MyNewsPage } from './pages/MyNewsPage/MyNewsPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/my-news" element={<MyNewsPage />} />
      <Route path="/most-read" element={<PlaceholderPage title="Most Read" />} />
      <Route path="/games" element={<PlaceholderPage title="Games" />} />
      <Route path="/sections" element={<PlaceholderPage title="Sections" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PlaceholderPage({ title }) {
  return (
    <main className="screen" role="main">
      <h1 className="screen__title">{title}</h1>
      <p className="text-muted">This page is reserved for future prototyping.</p>
    </main>
  );
}
